import { Box, CircularProgress, createStyles, Fab, makeStyles, Paper } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { TextValidator } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import FormDialog, { FormDialogProps } from '../../Components/FormDialog';
import FileInput, { TFile } from '../../Components/Input/FileInput';
import { PictureModel } from '../../Models/Pictures/Model';
import { OTag } from '../../Models/Tag';
import { Tag } from '../../Models/Tag/@types';
import { TDispatch } from '../../Resources/GarbageUtils';

interface TagFormProps extends Pick<FormDialogProps, 'open' | 'onCloseButtonClick'> {
    editedTag?: Tag;
}

const TagForm: FC<TagFormProps> = (props) => {



    const { editedTag, ...formDialogProps } = props;

    const [formData, setFormData] = useState<Partial<Tag>>(editedTag || { name: '' });
    const [picLoading, setPicLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const classes = useStyles();
    const dispatch = useDispatch<TDispatch>();

    const handlePictureSelect = async (files: TFile[]) => {
        setPicLoading(true);
        const res = await PictureModel.upload(files[0], formData.name || '', 'tags').catch(err => { console.log('Error', err.response) });
        if (res) {
            setFormData({ ...formData, _picture: res.data });
        }
        setPicLoading(false);
    }

    const handleSubmit = async () => {
        setLoading(true);
        const res = await dispatch(OTag.putItem(formData)).catch(error => { console.log('Error', error.response) });
        if (res) formDialogProps.onCloseButtonClick?.();
        setLoading(false);
    }

    return (
        <FormDialog {...formDialogProps} title={'Add Form'} onSubmit={handleSubmit} loading={loading} >
            <Paper className={classes.paper} >
                <TextValidator
                    name={'name'}
                    value={formData.name}
                    onChange={e => setFormData({ ...formData, name: (e.target as HTMLInputElement)['value'] })}
                    label={'Name'}
                    fullWidth
                    required
                />
                <Box className={classes.picture} >
                    {
                        picLoading ? <CircularProgress /> :
                            <Fab size='small' color='primary' disabled={picLoading} >
                                <FileInput onDone={handlePictureSelect} disabled={picLoading} withCropping cropConfig={{ aspect: 1 }} />
                                <i className={'material-icons'}>add</i>
                            </Fab>
                    }
                    {formData._picture?.url ? <img src={formData._picture.url} alt={formData.name} /> : null}
                </Box>
            </Paper>
        </FormDialog>
    )
}

const useStyles = makeStyles((theme) => {
    const { palette: { secondary } } = theme;
    return (createStyles({
        paper: {
            padding: 20
        },
        picture: {
            marginTop: 20,
            minHeight: 300,
            width: 300,
            backgroundColor: secondary['main'],
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            '& > button': {
                position: 'absolute',
                bottom: '16px', right: '16px'
            },
            '& img': {
                width: '100%'
            }
        }
    }))
})

export default TagForm